module.exports = __webpack_public_path__ + "img/root111.2801f36f.png";